import React, { FC, useCallback, useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

import { useQuery } from 'hooks';

import { DatePickerProps } from 'antd/lib/date-picker';
import { Filter } from 'components/FiltersBlock/types';

import { Wrapper, Label } from '../styled';
import { SelectPicker } from './styled';

const DATE_FORMAT = 'DD-MM-YYYY';

export const DatePickerFilter: FC<Props & DatePickerProps> = ({
  label,
  formatDate,
  dateName,
  notReplaceQuery = false,
  onFilterChange,
  ...props
}) => {
  const [dateValue, setDateValue] = useState<Dayjs>();

  const { query, replaceQuery } = useQuery();

  useEffect(() => {
    const { date } = query;
    const customQuery = dateName ? query[dateName] : '';
    const dateValue =
      customQuery || date
        ? dayjs((customQuery || date) as string, formatDate || DATE_FORMAT)
        : undefined;
    setDateValue(dateValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateName, query]);

  const onChange = useCallback(
    (value: Dayjs | null, date: string) => {
      /* TODO НЕТ ИМЕНИ!! */
      onFilterChange?.(date, name);

      if (notReplaceQuery) return;

      const { page } = query;
      setDateValue(value);
      replaceQuery({
        [dateName || 'date']: date || undefined,
        page: page ? 1 : undefined,
      });
    },
    [dateName, query, replaceQuery, notReplaceQuery, onFilterChange],
  );

  return (
    <Wrapper>
      <Label>{label}</Label>

      <SelectPicker
        value={dateValue}
        format={formatDate || DATE_FORMAT}
        size='small'
        onChange={onChange}
        {...props}
      />
    </Wrapper>
  );
};

interface Props extends Filter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFilterChange?: (value: any, name: string) => void;
}
